import { z } from 'zod';
import { USER_GROUP_CONSTRAINTS } from './constraints.js';
export const createUserGroupInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${USER_GROUP_CONSTRAINTS.name.label} is required.`)
        .max(USER_GROUP_CONSTRAINTS.name.maxLength),
    description: z.string().max(USER_GROUP_CONSTRAINTS.description.maxLength).optional().nullable(),
});
//# sourceMappingURL=create-input.js.map